import { Routes } from '@angular/router';

import { VendorsComponent } from './vendors/vendors.component';
import { InventoryComponent } from './inventory/inventory.component';
import { PriceHistoryComponent } from './price-history/price-history.component';
import { CentralizedfilesComponent } from './centralizedfiles/centralizedfiles.component';
import { VisitorlinkComponent } from './visitorlink/visitorlink.component';
import { ErasuremethodsComponent } from './erasuremethods/erasuremethods.component';
import { ContainerstypeComponent } from './containerstype/containerstype.component';
import { InventoryHistoryComponent } from './inventory-history/inventory-history.component';
import { ConfigptoComponent } from './configpto/configpto.component';
import { DetailComponent } from './inventory/detail/detail.component';
import { InventoryAttributesComponent } from './inventory/inventory-attributes/inventory-attributes.component';
import { RemoveHardDrivesComponent } from './inventory/remove-hard-drives/remove-hard-drives.component';
import { VisibilitytablesComponent } from './visibilitytables/visibilitytables.component';
import { BackgroundprocessComponent } from './backgroundprocess/backgroundprocess.component';

export const ModulosRoutes: Routes = [
    {

      path: '',
      children: [
          {
            path: 'vendors',
            component: VendorsComponent
          },
          {
            path: 'inventory',
            component: InventoryComponent
          },
          {
            path: 'inventory/:type/:id',
            component: DetailComponent
          },
          {
            path: 'priceHistory',
            component: PriceHistoryComponent
          },
          {
            path: 'centralizedfiles',
            component: CentralizedfilesComponent
          },
          {
            path: 'visitorlink',
            component: VisitorlinkComponent
          },
          {
            path: 'erasuremethods',
            component: ErasuremethodsComponent
          },
          {
            path: 'containerstype',
            component: ContainerstypeComponent
          },
          {
            path: 'inventoryhistory',
            component: InventoryHistoryComponent
          },
          {
            path: 'configpto',
            component: ConfigptoComponent
          },
          {
            path: 'inventory/attributes/:sn/:id/:type',
            component: InventoryAttributesComponent
          },
          {
            path: 'visibilitytables',
            component: VisibilitytablesComponent
          },
          {
            path: 'removeharddrives',
            component: RemoveHardDrivesComponent
          },
          {
            path: 'backgroundprocess',
            component: BackgroundprocessComponent
          }
      ]
    }
];
